<template>
  <div class="tabs">
    <div class="top-div">
      <div class="div-flex" :class="changeItems === 'effec' && !isSubject ? 'cur' : ''"
        @click="changeItems === 'effec' ? changeItems = '' : changeItems = 'effec'">
        <div class="title">{{ curEffecName ? curEffecName : '病种筛选' }}</div>
        <img v-if="changeItems === 'effec' && !isSubject" src="@/assets/images/questionBank/img(11).png" class="icon1"
          alt="">
        <img v-else src="@/assets/images/questionBank/img(10).png" class="icon1" alt="">
      </div>
      <div class="div-flex" :class="changeItems === 'level' && !isSubject ? 'cur' : ''"
        @click="changeItems === 'level' ? changeItems = '' : changeItems = 'level'">
        <div class="title">{{ curLevel ? 'level' + curLevel : '等级难度' }}</div>
        <img v-if="changeItems === 'level' && !isSubject" src="@/assets/images/questionBank/img(11).png" class="icon1"
          alt="">
        <img v-else src="@/assets/images/questionBank/img(10).png" class="icon1" alt="">
      </div>
    </div>
    <div class="dialog-con" v-if="changeItems === 'effec' && !isSubject">
      <div class="title">病种筛选</div>
      <div class="cons">
        <div class="item" v-for="(item, index) in effectArr" :key="index"
          :class="item.classCode === curEffec ? 'cur' : ''" @click="handleClikcItems(item)">
          {{ item && item.className }}
        </div>
      </div>
      <div class="change-btn">
        <div class="btn btn1" @click="handleReset">重置</div>
        <div class="btn btn2" @click="handleSubmit">完成</div>
      </div>
    </div>
    <div class="dialog-con dialog-con2" v-if="changeItems === 'level' && !isSubject">
      <div class="title">等级难度</div>
      <div class="cons">
        <div class="item" v-for="(item, index) in levelArr" :key="index" :class="item === curLevel ? 'cur' : ''"
          @click="handleClikcItems(item)">
          Level {{ item }}
        </div>
      </div>
      <div class="change-btn">
        <div class="btn btn1" @click="handleReset">重置</div>
        <div class="btn btn2" @click="handleSubmit">完成</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getLevel, getEffective } from '../../../api/questionBank'
export default {
  props: {
    isSubject: Boolean
  },
  data () {
    return {
      effectArr: [],
      levelArr: [],
      changeItems: '',
      curEffec: '',
      curEffecName: '',
      curLevel: '',
    }
  },
  mounted () {
    if (this.$route.query.classCode) {
      this.curEffec = this.$route.query.classCode
      this.curEffecName = this.$route.query.className
      this.curLevel = this.$route.query.difficultyLevel
    }
    getLevel().then(res => {
      this.levelArr = res.data
    })
    getEffective().then(res => {
      this.effectArr = res.data
    })
  },
  methods: {
    handleReset () {
      if (this.changeItems === 'level') {
        this.curLevel = ''
      } else {
        this.curEffec = ''
        this.curEffecName = ''
      }
    },
    handleClikcItems (item) {
      if (this.changeItems === 'level') {
        this.curLevel = item
      } else {
        this.curEffec = item.classCode
        this.curEffecName = item.className
      }
    },
    handleSubmit () {
      this.changeItems = ''
      this.$emit('updateList', { curEffec: this.curEffec, curLevel: this.curLevel })
    }
  }
}
</script>
<style lang="less" scoped>
.top-div {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 17px;
  box-sizing: border-box;

  .div-flex {
    display: flex;
    align-items: center;
    margin-right: 30px;

    &.cur {
      .title {
        font-weight: bold;
      }
    }

    .title {
      font-size: 14px;
      color: #333333;
      font-weight: 400;
      margin-right: 4px;
    }

    .icon1 {
      width: 8px;
      display: block;
    }
  }
}

.dialog-con {
  position: absolute;
  top: 49px;
  width: 100%;
  left: 0;
  background-color: #fff;
  z-index: 9;
  padding: 17px;
  box-sizing: border-box;

  .title {
    font-size: 15px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.9);
    line-height: 22px;
  }

  .cons {
    display: flex;
    flex-wrap: wrap;

    .item {
      width: 106px;
      height: 35px;
      text-align: center;
      line-height: 35px;
      border-radius: 8px;
      background-color: #F2F3F7;
      margin-top: 10px;
      font-size: 13px;
      font-weight: 500;
      color: rgba(106, 116, 129, 0.9);

      &.cur {
        color: #EB1700;
      }

      &:nth-child(3n-1) {
        margin: 0 8px;
        margin-top: 10px;
      }
    }
  }

  .change-btn {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 17px;
    height: 40px;
    box-sizing: border-box;
    background-color: #fff;
    margin-top: 20px;

    .btn {
      flex: 1;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 15px;

      &.btn1 {
        border: 1px solid #F2F3F7;
        border-radius: 8px 0px 0px 8px;
        color: rgba(0, 0, 0, 0.9);
        box-sizing: border-box;
      }

      &.btn2 {
        background-color: #EB1700;
        border-radius: 0px 8px 8px 0px;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/questionBank/components/tabs.vue